import * as React from 'react';

import { Bone } from '@lightspeed/flame/Bone';
import { Box } from '@lightspeed/flame/Core';
import { Divider } from '@lightspeed/flame/Divider';

const BoneBox: React.FC = () => (
  <Box my={3}>
    <Bone width="95%" />
  </Box>
);

const Loading: React.FC = () => (
  <>
    <BoneBox />
    <Divider />
    <BoneBox />
  </>
);

export default Loading;
